"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CountryCard = require("../CountryCard/CountryCard");
var _RecommendedCountries = _interopRequireDefault(require("../RecommendedCountries/RecommendedCountries"));
var RecommendedCountryCarousel = function RecommendedCountryCarousel(props) {
  var className = props.className,
    recommendations = props.recommendations,
    countries = props.countries,
    isMobile = props.isMobile;
  var hasRecommendations = Array.isArray(recommendations);
  return /*#__PURE__*/_react["default"].createElement(StyledRecommendedCoutnryCarousel, {
    className: className
  }, hasRecommendations ? /*#__PURE__*/_react["default"].createElement(_RecommendedCountries["default"], {
    isMobile: isMobile,
    recommendations: recommendations
  }) : null, Array.isArray(countries) && countries.map(function (country, i) {
    return /*#__PURE__*/_react["default"].createElement(StyledCountryCard, (0, _extends2["default"])({
      isFirst: i === 0,
      key: country.text,
      isMobile: isMobile
    }, country));
  }));
};
var StyledCountryCard = (0, _styledComponents["default"])(_CountryCard.CountryCard).withConfig({
  displayName: "RecommendedCountryCarousel__StyledCountryCard",
  componentId: "sc-54evu6-0"
})(["margin-left:", "px;"], function (_ref) {
  var isFirst = _ref.isFirst;
  return isFirst ? 0 : 8;
});
var StyledRecommendedCoutnryCarousel = _styledComponents["default"].div.withConfig({
  displayName: "RecommendedCountryCarousel__StyledRecommendedCoutnryCarousel",
  componentId: "sc-54evu6-1"
})(["display:flex;overflow-x:auto;&::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;"]);
var _default = exports["default"] = RecommendedCountryCarousel;